import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/icons.css";
import "../../assets/css/style.css";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from "../../Server";
import axios from "axios";
import { DeleteIcon, EditIcon, HomeIcon } from "../../assets/Icons";
import TableSkelton from "../../skeltonloader/TableSkelton";
import NoDataFound from "../../common/NoDataFound";
import { NavLink } from "react-router-dom/cjs/react-router-dom";

class ListRange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      List: [],
      message: "",
      searchVal: "",
      loading: true,
    };
  }

  componentDidMount() {
    this.getList();
  }
  getList = () => {
    this.setState({ loading: true });
    var data = {
      sid: ud.main_id,
    };
    let _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/RangeList`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          if (response.data.listRange) {
            _this.setState({
              List: response.data.listRange,
              message: response.data.listRange.length === 0 ? "No Record Found." : "",
            });
          }
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.getList();
            }
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => this.setState({ loading: false }));
  };
  createBank = () => {
    window.location.href = "/create/rangebankcreate";
  };
  EditMcq = (list) => {
    sessionStorage.setItem("range_bank_edit", JSON.stringify(list));
    window.location.href = "/create/rangebankedit";
  };
  render() {
    const { errors } = this.state;
    return (
      <div>
        <div class="xp-breadcrumbbar">
          <div class="row">
            <div className="col-md-12 my-3">
              <h3 className="xp-page-title">Range Library</h3>
            </div>
            <div class="col-md-10 col-lg-10">
              <div class="xp-breadcrumb mt-0 gradient-border">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a onClick={() => (window.location.href = "/dashboard")}>
                      <i>
                        <HomeIcon />{" "}
                      </i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">Range library list</li>
                </ol>
              </div>
            </div>
            <div class="col-md-2 col-lg-2 text-right">
              <NavLink
                className="btn btn-white btn-lg rounded border p-11"
                title="Create Range Library"
                to="/create/rangebankcreate"
                // onClick={this.createBank}
              >
                <i className="mdi mdi-plus mr-2"></i>Create Range Library
              </NavLink>
            </div>
          </div>
        </div>
        <div class="xp-contentbar p-30">
          <div class="row">
            <div class="col-lg-12">
              <div class="card document_gradient_border padding-0 m-b-30">
                <div class="card-header dv-center space-between border-radius-top-15">
                  <h5 class="card-title mb-0">Range Library List</h5>
                  <div className="autocomplete_search">
                    <input
                      type="text"
                      className="form-control ml-2"
                      //   onChange={this.search_bar}
                      name=""
                      //   value={this.state.searchVal}
                      placeholder="Search Range Library ..."
                    />
                    {this.state.searchVal === "" ? (
                      <span className="icon-search">
                        <svg
                          focusable="false"
                          height="24px"
                          viewBox="0 0 24 24"
                          width="24px"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M20.49,19l-5.73-5.73C15.53,12.2,16,10.91,16,9.5C16,5.91,13.09,3,9.5,3S3,5.91,3,9.5C3,13.09,5.91,16,9.5,16 c1.41,0,2.7-0.47,3.77-1.24L19,20.49L20.49,19z M5,9.5C5,7.01,7.01,5,9.5,5S14,7.01,14,9.5S11.99,14,9.5,14S5,11.99,5,9.5z"></path>
                          <path d="M0,0h24v24H0V0z" fill="none"></path>
                        </svg>
                      </span>
                    ) : (
                      <span className="icon-close-search">
                        <svg
                          focusable="false"
                          height="24px"
                          onClick={this.closeSearch}
                          viewBox="0 0 24 24"
                          width="24px"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                          <path d="M0 0h24v24H0z" fill="none"></path>
                        </svg>
                      </span>
                    )}
                  </div>
                </div>

                <div class="card-body">
                  <div class="table-responsive">
                    {/* {this.state.List.length === 0 ? (
                      this.state.message === "" ? (
                        // loader
                        <div className="lds-spinner">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      ) : (
                        // loader-end
                        <div className="message-no-record"> {this.state.message} </div>
                      )
                    ) : null} */}
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th className="text-center" style={{ width: "5%" }}>
                            S.N.
                          </th>
                          <th>Question</th>
                          <th className="text-center">Minimum Value</th>
                          <th className="text-center">Maximum Value</th>

                          <th className="text-center" style={{ width: "15%" }}>
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading ? (
                          <TableSkelton rowCount={3} colCount={5} />
                        ) : this.state.List.length === 0 ? (
                          <tr>
                            <td colSpan={5}>
                              <NoDataFound headText={"No Range List Found"} />
                            </td>
                          </tr>
                        ) : (
                          this.state.List.map((list, index) => (
                            <tr>
                              <td className="text-center">
                                <strong>{index + 1}.</strong>
                              </td>
                              <td>{list.question}</td>
                              <td className="text-center">{list.min_value}</td>
                              <td className="text-center">{list.max_value}</td>

                              <td className="text-center">
                                <div
                                  class="tabledit-toolbar btn-toolbar"
                                  style={{ margin: "0 auto", display: "block" }}
                                >
                                  <div class="btn-group btn-group-sm">
                                    <button
                                      type="button"
                                      title="Edit"
                                      onClick={() => this.EditMcq(list)}
                                      class=" btn  btn-info"
                                    >
                                      <i>
                                        <EditIcon />{" "}
                                      </i>
                                    </button>
                                    {/* <button
                                      type="button"
                                      title="Delete"
                                      class=" btn  btn-info"
                                    >
                                      <i>
                                          <DeleteIcon />{" "}
                                      </i>
                                    </button> */}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                  {/* <nav aria-label="Page navigation example">
                                  <ul class="pagination justify-content-end">
                                    <li class="page-item disabled">
                                      <a class="page-link" href="#" tabindex="-1">Previous</a>
                                    </li>
                                    <li class="page-item"><a class="page-link" href="#">1</a></li>
                                    <li class="page-item"><a class="page-link" href="#">2</a></li>
                                    <li class="page-item"><a class="page-link" href="#">3</a></li>
                                    <li class="page-item">
                                      <a class="page-link" href="#">Next</a>
                                    </li>
                                  </ul>
                                </nav> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ListRange;
